export const FEED_BANNERS = [
  {
    pp: 'qjo',
    ps: 'dcno',
    p2: 'gfzm',
  },
  {
    pp: 'qjp',
    ps: 'dcno',
    p2: 'gfzm',
  },
  {
    pp: 'qjn',
    ps: 'dcno',
    p2: 'gfzm',
  },
];

export const FEED_BANNER_TOP_POSITION = 3;
export const FEED_BANNER_BOTTOM_POSITION = 8;

export const FEED_BANNER_TOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175809005290561308',
  params: {
    pp: 'gwvq',
    ps: 'dcno',
    p2: 'jonq',
    insertAfter: 'undefined',
    insertPosition: '0',
    stick: false,
    stickTo: 'auto',
    stickyColorScheme: 'light',
  },
};

export const FEED_BANNER_BOTTOM_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821400938761308',
  params: {
    pp: 'gwvu',
    ps: 'dcno',
    p2: 'jonq',
  },
};

export const BANNER_CHRONICLE_HALVED_A_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821423974171308',
  params: {
    pp: 'gxhx',
    ps: 'dcno',
    p2: 'joor',
  },
};

export const BANNER_CHRONICLE_HALVED_A_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821428088431308',
  params: {
    pp: 'gxhy',
    ps: 'dcno',
    p2: 'joos',
  },
};

export const BANNER_CHRONICLE_HALVED_A_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821431804521308',
  params: {
    pp: 'gxhz',
    ps: 'dcno',
    p2: 'joot',
  },
};

export const BANNER_CHRONICLE_HALVED_B_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821435464991308',
  params: {
    pp: 'gxia',
    ps: 'dcno',
    p2: 'joor',
  },
};

export const BANNER_CHRONICLE_HALVED_B_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821439123911308',
  params: {
    pp: 'gxib',
    ps: 'dcno',
    p2: 'joos',
  },
};

export const BANNER_CHRONICLE_HALVED_B_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821443461681308',
  params: {
    pp: 'gxic',
    ps: 'dcno',
    p2: 'joot',
  },
};

export const BANNER_CHRONICLE_HALVED_C_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854805938231308',
  params: {
    pp: 'gxrw',
    ps: 'dcno',
    p2: 'joor',
  },
};

export const BANNER_CHRONICLE_HALVED_C_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854810670911308',
  params: {
    pp: 'gxry',
    ps: 'dcno',
    p2: 'joos',
  },
};

export const BANNER_CHRONICLE_HALVED_C_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854815154771308',
  params: {
    pp: 'gxrx',
    ps: 'dcno',
    p2: 'joot',
  },
};

export const BANNER_CHRONICLE_HALVED_D_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854819796051308',
  params: {
    pp: 'gxsb',
    ps: 'dcno',
    p2: 'joor',
  },
};

export const BANNER_CHRONICLE_HALVED_D_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_17585482386591308',
  params: {
    pp: 'gxsd',
    ps: 'dcno',
    p2: 'joos',
  },
};

export const BANNER_CHRONICLE_HALVED_D_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854827026521308',
  params: {
    pp: 'gxsc',
    ps: 'dcno',
    p2: 'joot',
  },
};

export const BANNER_CHRONICLE_FULL_A_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176112934763591308',
  params: {
    pp: 'hetq',
    ps: 'dcno',
    p2: 'jooo',
  },
};

export const BANNER_CHRONICLE_FULL_A_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176112951775771308',
  params: {
    pp: 'hetr',
    ps: 'dcno',
    p2: 'joop',
  },
};

export const BANNER_CHRONICLE_FULL_A_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176112954920891308',
  params: {
    pp: 'hets',
    ps: 'dcno',
    p2: 'jooq',
  },
};

export const BANNER_CHRONICLE_FULL_B_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821448424261308',
  params: {
    pp: 'gxid',
    ps: 'dcno',
    p2: 'jooo',
  },
};

export const BANNER_CHRONICLE_FULL_B_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821452694521308',
  params: {
    pp: 'gxie',
    ps: 'dcno',
    p2: 'joop',
  },
};

export const BANNER_CHRONICLE_FULL_B_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821456099541308',
  params: {
    pp: 'gxif',
    ps: 'dcno',
    p2: 'jooq',
  },
};

export const BANNER_CHRONICLE_FULL_C_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854847054561308',
  params: {
    pp: 'gxsg',
    ps: 'dcno',
    p2: 'jooo',
  },
};

export const BANNER_CHRONICLE_FULL_C_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854851436351308',
  params: {
    pp: 'gxse',
    ps: 'dcno',
    p2: 'joop',
  },
};

export const BANNER_CHRONICLE_FULL_C_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175854855455941308',
  params: {
    pp: 'gxsf',
    ps: 'dcno',
    p2: 'jooq',
  },
};

export const BANNER_ARTICLE_MIDDLE_A_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175869918653141308',
  params: {
    pp: 'gybh',
    ps: 'dcno',
    p2: 'jorb',
  },
};

export const BANNER_ARTICLE_MIDDLE_A_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175869920848521308',
  params: {
    pp: 'gybi',
    ps: 'dcno',
    p2: 'jorc',
  },
};

export const BANNER_ARTICLE_MIDDLE_A_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175869923079321308',
  params: {
    pp: 'gybj',
    ps: 'dcno',
    p2: 'jord',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_A_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821406307091308',
  params: {
    pp: 'gxhu',
    ps: 'dcno',
    p2: 'jooo',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_A_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821410519981308',
  params: {
    pp: 'gxhv',
    ps: 'dcno',
    p2: 'joop',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_A_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175821415683861308',
  params: {
    pp: 'gxhw',
    ps: 'dcno',
    p2: 'jooq',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_B_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175879434559621308',
  params: {
    pp: 'gygb',
    ps: 'dcno',
    p2: 'jooo',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_B_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175879436847081308',
  params: {
    pp: 'gygc',
    ps: 'dcno',
    p2: 'joop',
  },
};

export const BANNER_ARTICLE_BOUNDARY_FULL_B_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175879442153411308',
  params: {
    pp: 'gygd',
    ps: 'dcno',
    p2: 'jooq',
  },
};

export const BANNER_SITE_TOP_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175968462444561308',
  params: {
    pp: 'gzqs',
    ps: 'dcno',
    p2: 'jovf',
  },
};

export const BANNER_SITE_TOP_TABLET_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175968464311281308',
  params: {
    pp: 'gzqt',
    ps: 'dcno',
    p2: 'jovg',
  },
};

export const BANNER_SITE_TOP_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_175968467061181308',
  params: {
    pp: 'gzqu',
    ps: 'dcno',
    p2: 'jovh',
  },
};

export const BANNER_SITE_BOTTOM_FIXED_DESKTOP_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176094734948621308',
  params: {
    pp: 'heac',
    ps: 'dcno',
    p2: 'jpan',
  },
};

export const BANNER_SITE_BOTTOM_FIXED_MOBILE_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176094737239021308',
  params: {
    pp: 'head',
    ps: 'dcno',
    p2: 'jpao',
  },
};

export const BANNER_SITE_BOTTOM_FIXED_TEST_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_176537385354761308',
  params: {
    pp: 'hpbk',
    ps: 'dcno',
    p2: 'jpan',
  },
};

export const BANNER_BRANDING_MAIN_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_177132449603211308',
  params: {
    pp: 'ibni',
    ps: 'dcno',
    p2: 'jrch',
  },
};

export const BANNER_BRANDING_TEST_PARAMS = {
  ownerId: '203169',
  containerId: 'adfox_177479660777331308',
  params: {
    pp: 'idfa',
    ps: 'dcno',
    p2: 'jrhu',
  },
};
